import React, { useEffect, useState } from 'react';
import styles from './business-points-card.module.scss';
import { SearchInput, DefaultButton, PointMiniCard } from 'shared/ui';
import { useNavigate } from 'react-router-dom';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { observer } from 'mobx-react';
import { businessStore, UserRoleEnum, userStore } from 'entities/index';

interface IBusinessPointsCardProps {
  businessId: string;
}

export const BusinessPointsCard: React.FC<IBusinessPointsCardProps> = observer(
  ({ businessId }) => {
    const [inputValue, setInputValue] = useState('');
    const navigate = useNavigate();

    const normalizedSearch = inputValue.toLowerCase().trim();

    const matchesSearch = (point: {
      name?: string;
      address?: string;
      administrator?: { fio?: string };
    }): boolean => {
      if (!normalizedSearch) return true;
      return !!(
        point.name?.toLowerCase().includes(normalizedSearch) ||
        point.address?.toLowerCase().includes(normalizedSearch) ||
        point.administrator?.fio?.toLowerCase().includes(normalizedSearch)
      );
    };

    useEffect(() => {
      businessStore.initPointsWidgetData(businessId);
    }, []);

    const navigateToCreatePoint = () => {
      const path = AppLinks.CreatePointLink.replace(':id', businessId);
      navigate(path);
    };

    return (
      <div className={styles.business_points__container}>
        <div className={styles.container__search}>
          <SearchInput
            value={inputValue}
            placeholder="Поиск по точкам"
            onChange={setInputValue}
          />
        </div>
        <div className={styles.container__content}>
          <div className={styles.content}>
            {businessStore.pointsWidgetData
              ?.filter(matchesSearch)
              .map((point, index) => (
                <PointMiniCard pointInfo={point} key={index} />
              ))}
          </div>
        </div>

        {userStore.role === UserRoleEnum.OWNER ? (
          <div className={styles.container__button}>
            <div
              className={styles.button__wrapper}
              onClick={navigateToCreatePoint}
            >
              <DefaultButton buttonText="Создать точку" />
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  }
);
